import React from "react";
import styled from "styled-components";
import { useCurrentFrame } from "../use-current-frame";
import { spring } from "../Spring";

const Container = styled.div`
    display: inline-flex;
    /* overflow: hidden; */
`;

const Holder = styled.span``;

function PopAnimation(props) {
    const frame = useCurrentFrame();

    const { children } = props;

    const scale = spring({
        frame: frame,
        fps: (props.videoConfig || {}).fps || 30,
    });

    return (
        <Container>
            <Holder
                style={{
                    transform: `scale(${scale})`,
                }}
            >
                {children}
            </Holder>
        </Container>
    );
}

export default React.memo(PopAnimation);
